export default __webpack_public_path__ + "static/media/try-it.9f1eef0e.svg";